import "simplebar-react/dist/simplebar.min.css";
import ShopSimpleBar from "./ShopComponents/ShopSimpleBar";
import ShopHeader from "./ShopComponents/ShopHeader";
import ShopTitleButtons from "./ShopComponents/ShopTitleButtons";
import {headerData} from "./ArraysTexts/HeaderText";
import ShopTitle from "./ShopComponents/ShopTitle";
import {titleText} from "./ArraysTexts/TitleText";

function UCPShopMainRender() {
    return (
        <div className="shop-container">
            <ShopHeader typeIndex={0}/>
            <ShopTitle {...titleText[0]}/>
            <ShopTitleButtons/>
            <ShopSimpleBar/>
        </div>
    );
}

export const ShopMain = () => UCPShopMainRender();